import { gql } from "@apollo/client";

const GET_SALES =
  gql(`query Query($aggregate: Aggregate, $filter: FilterSalesInput) {
    sales(aggregate: $aggregate, filter: $filter)
  }
  `);

const GET_REVENUE =
  gql(`query Query($aggregate: Aggregate, $filter: FilterSalesInput) {
  revenue(aggregate: $aggregate, filter: $filter)
}
  `);

const GET_REGISTERS =
  gql(`query Query($aggregate: Aggregate, $filter: FilterUserInput) {
  registeredUsers(aggregate: $aggregate, filter: $filter)
}
  `);

const GET_REGISTERS_BY_PROGRESS =
  gql(`query Query {
  registersByProgress
}
  `);

const GET_USER_REPORT = gql(`
  query Query($id: ID!) {
  userReport(id: $id)
}
  `)

export { GET_SALES, GET_REVENUE, GET_REGISTERS, GET_REGISTERS_BY_PROGRESS, GET_USER_REPORT };
